const defaultBreakpoints = [
   { code: "xs", min: 0 },
   { code: "sm", min: 576 },
   { code: "md", min: 768 },
   { code: "lg", min: 992 },
   { code: "xl", min: 1200 },
];

const calcBreakpoint = (breakpointArray) => {
   // Determine the appropriate breakpoint by starting at the largest min-width and stepping down until the media query is positive

   let breakpointIndex = breakpointArray.length - 1;

   while (breakpointIndex >= 0) {
      const mediaQuery1 = window.matchMedia(
         `(min-width: ${breakpointArray[breakpointIndex].min}px)`
      ).matches;
      if (mediaQuery1) break;
      breakpointIndex -= 1;
   }

   // This first breakpoints array item should always be zero so the calculated breapoint will never be less than zero

   return breakpointArray[breakpointIndex];
};

var state = {
   webp: false,
   breakpoint: calcBreakpoint(defaultBreakpoints),
   breakpoints: defaultBreakpoints,
   size: {
      width: window.innerWidth,
      height: window.innerHeight,
   },
   scroll: {
      x: window.scrollX,
      y: window.scrollY,
   },
   orientation: window.screen.orientation,
};

var mutations = {
   updateSize: (state) => {
      state.breakpoint = calcBreakpoint(state.breakpoints).code;
      state.size = {
         width: window.innerWidth,
         height: window.innerHeight,
      };
      state.orientation = window.screen.orientation;
   },
   updateScroll: (state) => {
      state.scroll = {
         x: window.scrollX,
         y: window.scrollY,
      };
   },
   setWebp: (state, flag) => {
      state.webp = flag;
   },
};

var actions = {};

var getters = {
	// breakpoint: state => state.breakpoint
};

var index = {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};

export default index;
